import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=18b5ece9&scoped=true"
import script from "./AdminClients.vue?vue&type=script&lang=ts"
export * from "./AdminClients.vue?vue&type=script&lang=ts"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=18b5ece9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5ece9",
  null
  
)

export default component.exports